import * as React from 'react';

import * as ReactDOM from 'react-dom/client';

import '@rematter/ui-web/styles.css';

import App from './app/app';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
